import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'LINEARREG_ANGLE',
  version: 1,
  label: 'Linear Regression Angle',
  pane: 'sub',
  category: 'statistics',
  series: 'normal',
  precision: 2,
  order: 40,
  inputs: [period('timeperiod', 14)],
  outputs: [line('angle', 'Angle', COLOR.blue)],
  levels: [{ value: 0 }],
  talib: { functions: ['LINEARREG_ANGLE'], expr: 'LINEARREG_ANGLE(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
